import React from 'react'
import { Container } from './styles'
import { CheckUpFilters } from '../CheckUpFilters'
import { CheckUpStatusDescription } from '../CheckUpStatusDescription'

export const Header = (): JSX.Element => {
  return (
    <Container>
      <CheckUpFilters />
      <CheckUpStatusDescription />
    </Container>
  )
}
